import React, { createContext, useContext, useEffect, useLayoutEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always use dark theme
  const theme = 'dark';
  const [isMounted, setIsMounted] = React.useState(false);

  // Set dark theme before browser paints
  useLayoutEffect(() => {
    // Apply dark theme to document
    document.documentElement.setAttribute('data-theme', 'dark');
    document.body.className = 'dark';
    
    // Mark as mounted
    setIsMounted(true);
  }, []);

  // Don't render children until theme is set to prevent flash
  if (!isMounted) {
    return null;
  }

  const value = {
    theme,
    toggleTheme: () => {}, // No-op since we only have one theme
    isLight: false,
    isDark: true
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
